<template>
  <section
    v-if="data && data.blocks"
    class="collapse padding_large"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation]"
  >
    <ModuleContainer>
      <v-collapse-wrapper
        @beforeClose="startClose"
        @beforeOpen="startOpen"
        v-for="(item, k) in data.blocks"
        :key="k"
      >
        <div class="header" v-collapse-toggle>
          {{ item.title }}
        </div>
        <div class="my-content" v-collapse-content>
          <DynamicHtml class="content" :html="item.content" />
        </div>
      </v-collapse-wrapper>
    </ModuleContainer>
  </section>
</template>

<script>
const jQuery = window.jQuery;

export default {
  name: "collapse",
  props: ["data"],
  computed: {},
  components: {},
  methods: {
    startOpen(e) {
      jQuery(e.$el).addClass("is-open");
    },
    startClose(e) {
      jQuery(e.$el).removeClass("is-open");
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.collapse {
  .is-open {
    .header {
      &:after {
        transform: rotate(-135deg);
      }
    }
  }
  .header {
    background-color: #f6f6f6;
    cursor: pointer;
    padding: 15px;
    @include fluid-type($smallResText, $wideResText, 15px, 26px);
    font-weight: 800;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:after {
      content: "";
      display: block;
      border: solid black;
      border-width: 0 4px 4px 0;
      display: inline-block;
      padding: 4px;
      margin-right: 10px;
      transform: rotate(45deg);
      transition: transform 0.2s ease-in-out;
    }
  }
  .my-content {
    .content {
      border: 2px solid #eee;
      padding: 15px;
    }
  }
  .vc-collapse {
    margin-bottom: 30px;
    @include mquery(1260px) {
      margin-bottom: 15px;
    }
    @include mquery(767px) {
      margin-bottom: 10px;
    }
  }
}
.v-collapse-content {
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  padding: 0;
}

.v-collapse-content-end {
  transition: max-height 0.3s ease-in;
  max-height: 500px;
}
</style>
